import { render, staticRenderFns } from "./HiddenTabGroup.vue?vue&type=template&id=c824015c&scoped=true"
import script from "./HiddenTabGroup.vue?vue&type=script&lang=js"
export * from "./HiddenTabGroup.vue?vue&type=script&lang=js"
import style0 from "./HiddenTabGroup.vue?vue&type=style&index=0&id=c824015c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c824015c",
  null
  
)

export default component.exports